module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "cols2"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "xxl"
  }, [_c('video', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": require("../assets/media/sortie_usine.mp4"),
      "autoplay": "",
      "loop": "",
      "poster": "http://mc3.co/Lumiere/static/media/sortie_usine.jpg"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": require("../assets/media/catalogue_general.jpg")
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": require("../assets/media/portrait.jpg")
    }
  })]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("From the Lumière film boxes manufactured in the family factories to tactile digital screens, the scenographic displays illustrate these evolutions in an intrinsic manner. The didactic and educational exhibition gives pride of place to the importance of the cinema image that at the beginning of the twenty-first century is sometimes relegated to the miniature space of a mobile telephone screen. Appealing to the spectator’s sensitivity and emotions, the journey and the scenographic installation contribute to ‘re-enchanting’ the images and re-confer their original magic upon them.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("Inventing Cinema provides visitors with the opportunity to rewind the history of the animated image, from its origins through to the latest production and screening techniques. Over a century separates the first cinematographic experiments from cinema as we know it today. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("Discover the prodigious beginning of the movie industry through the heritage and the archive of the Lumière Brothers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("The exhibition invites visitors to dive into the rich and creative avant-garde work of the Lumière brothers, examine the aesthetic and technical heritage. How cinema has grown and our relationship to images. It is unique opportunity to compare fixed or animated images from the past with those of the digital era, to think about issues relating to images, the technique and the way they have been 'received' throughout cinema’s history. ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fd34f43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = 45
// module chunks = 0